export const COA = {
    "active" : "ACTIVE",
    "upcoming" : "UPCOMING",
    "completed" : "COMPLETED",
    "cancelled" : "CANCELLED",
    "draft" : "DRAFT"
};
export const ACTIVE = [
    {
        "field": "ccdNo",
        "header": "CCD #"
    },
    {
        "field": "customer",
        "header": "Customer name"
    },
    {
        "field": "lob",
        "header": "LOB"
    },
    {
        "field": "owner",
        "header": "Owner"
    },
    {
        "field": "coaType",
        "header": "Type of COA"
    },
    {
        "field": "submittedAt",
        "header": "Start date"
    },
    {
        "field": "dueBy",
        "header": "Due date"
    },
    {
        "field": "",
        "header": ""
    },
    {
        "field": "",
        "header": ""
    }
];
export const UPCOMING = [
    {
        "field": "ccdNo",
        "header": "CCD #"
    },
    {
        "field": "customer",
        "header": "Customer name"
    },
    {
        "field": "lob",
        "header": "LOB"
    },
    {
        "field": "owner",
        "header": "Owner"
    },
    {
        "field": "coaType",
        "header": "Type of COA"
    },
    {
        "field": "coaStartDate",
        "header": "COA start date"
    },
    {
        "field": "coaEndDate",
        "header": "COA end date"
    },
    {
        "field": "pursueCcd",
        "header": "Pursue CCD"
    },
    {
        "field": "",
        "header": ""
    }
];
export const COMPLETED = [
    {
        "field": "ccdNo",
        "header": "CCD #"
    },
    {
        "field": "customer",
        "header": "Customer name"
    },
    {
        "field": "lob",
        "header": "LOB"
    },
    {
        "field": "owner",
        "header": "Owner"
    },
    {
        "field": "coaType",
        "header": "Type of COA"
    },
    {
        "field": "submittedAt",
        "header": "Start date"
    },
    {
        "field": "coaEndDate",
        "header": "COA end date"
    },
    {
        "field": "datePublished",
        "header": "Date published"
    }
];
export const CANCELLED = [
    {
        "field": "ccdNo",
        "header": "CCD #"
    },
    {
        "field": "customer",
        "header": "Customer name"
    },
    {
        "field": "lob",
        "header": "LOB"
    },
    {
        "field": "owner",
        "header": "Owner"
    },
    {
        "field": "coaType",
        "header": "Type of COA"
    },
    {
        "field": "submittedAt",
        "header": "Start date"
    },
    {
        "field": "dueBy",
        "header": "Due date"
    },
    {
        "field": "cancellationNotes",
        "header": "Cancellation notes"
    },
    {
        "field": "",
        "header": ""
    }
];
export const DRAFT = [
    {
        "field": "ccdNo",
        "header": "CCD #"
    },
    {
        "field": "customer",
        "header": "Customer name"
    },
    {
        "field": "lob",
        "header": "LOB"
    },
    {
        "field": "owner",
        "header": "Owner"
    },
    {
        "field": "coaType",
        "header": "Type of COA"
    },
    {
        "field": "createdAt",
        "header": "Start date"
    },
    {
        "field": "dueBy",
        "header": "Due date"
    },
    {
        "field": "",
        "header": ""
    },
    {
        "field": "",
        "header": ""
    }
];

export const DEPARTMENTS = [
    {
        fieldName: 'LEGAL',
        header: 'Legal department',
        visibleIn : ['NEW_COA', 'NEW_RATES_AND_TERMS', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE'],
    },
    {
        fieldName: 'ACCOUNTING',
        header: 'Accounting department',
        visibleIn : ['NEW_COA', 'NEW_RATES_AND_TERMS', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE', 'FINANCIAL_NEGOTIATIONS'],
        initialNotes: {
            FINANCIAL_NEGOTIATIONS: 'Please advise on any outstanding claims only'
        }
    },
    {
        fieldName: 'OPERATIONS_MANAGER',
        header: 'Operations manager',
        visibleIn : ['NEW_COA','NEW_RATES_AND_TERMS', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE']
    },
    {
        fieldName: 'TANKER',
        header: 'Tanker controller',
        visibleIn : ['NEW_COA', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE'],
        initialNotes: {
            NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE: 'Please advise only if bunker clause changed.'
        }
    },
    {
        fieldName: 'DEMURRAGE',
        header: 'Demurrage',
        visibleIn : ['NEW_COA', 'NEW_RATES_AND_TERMS', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE', 'FINANCIAL_NEGOTIATIONS'],
        initialNotes: {
            NEW_RATES_AND_TERMS: 'Please advise on terms and outstanding claims only',
            NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE: 'Please advise on terms and outstanding claims only',
            FINANCIAL_NEGOTIATIONS: 'Please advise on any outstanding claims only'
        }
    },
    {
        fieldName: 'GROUP_RISK',
        header: 'Group risk',
        visibleIn : ['NEW_COA', 'NEW_RATES_AND_TERMS', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE', 'FINANCIAL_NEGOTIATIONS'],
        initialNotes: {
            NEW_RATES_AND_TERMS: 'Please advise on any claims history only',
            NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE: 'Please advise on any claims history only',
            FINANCIAL_NEGOTIATIONS: 'Please advise on any claims history only'
        }
    },
    {
        fieldName: 'MANAGEMENT',
        header: 'Management approval',
        visibleIn : ['NEW_COA', 'NEW_RATES_AND_TERMS', 'NEW_RATES_AND_TERMS_WITH_NEW_CLAUSE', 'FINANCIAL_NEGOTIATIONS']
    }
];
export const DEPARTMENTORDER = [
    "LEGAL", 
    "ACCOUNTING", 
    "OPERATIONS_MANAGER", 
    "TANKER", 
    "DEMURRAGE", 
    "GROUP_RISK", 
    "MANAGEMENT", 
    "OWNER"
  ];
export const DEPARTMENTTABSORDER = [
    "OWNER",
    "LEGAL", 
    "ACCOUNTING", 
    "OPERATIONS_MANAGER", 
    "TANKER", 
    "DEMURRAGE", 
    "GROUP_RISK", 
    "MANAGEMENT"
  ];
export const DEPARTMENTMAPPING = { 
    "OWNER": "Owner",
    "LEGAL": "Legal", 
    "ACCOUNTING": "Accounting", 
    "OPERATIONS_MANAGER": "Operations manager", 
    "TANKER": "Tanker controller", 
    "DEMURRAGE": "Demurrage", 
    "GROUP_RISK": "Group risk", 
    "MANAGEMENT": "Management"
};
export const USERTABS = [
    {
        key: "CREATOR",
        value: "CCD owner/admin"
    },
    {
        key: "LEGAL",
        value: "Legal"
    },
    {
        key: "ACCOUNTING",
        value: "Accounting"
    },
    {
        key: "OPERATIONS_MANAGER",
        value: "Operations manager"
    },
    {
        key: "TANKER",
        value: "Tanker controller"
    },
    {
        key: "DEMURRAGE",
        value: "Demurrage"
    },
    {
        key: "GROUP_RISK",
        value: "Group risk"
    },
    {
        key: "VIEW_ONLY",
        value: "View only"
    }
];
